import { type CSSProperties } from "react";
import { useNumericScreenSize } from "~/common/hooks/useNumericScreenSize";

// Padding on the left side of the grid container - because filter title touches the edge of the screen otherwise
const LEFT_SIDE_PADDING = "8px";
export const FULLBLEED_LEFT_SIZE = "--fullbleed-left";
export const GRID_CONTAINER_FULLBLEED_STYLE: CSSProperties = {
  position: "relative",
  left: `calc(-1 * var(${FULLBLEED_LEFT_SIZE}) + ${LEFT_SIDE_PADDING})`,
};

export const getTableFullbleedStyle = (screenSize: number): CSSProperties => {
  if (screenSize < useNumericScreenSize.desktopM) {
    return TABLE_FULLBLEED_STYLE_WITHOUT_FILTERS;
  }

  return TABLE_FULLBLEED_STYLE_WITH_FILTERS;
};

const TABLE_FULLBLEED_STYLE_WITH_FILTERS: CSSProperties = {
  width: `calc(100% + 2 * var(${FULLBLEED_LEFT_SIZE}) - ${LEFT_SIDE_PADDING})`,
};

const TABLE_FULLBLEED_STYLE_WITHOUT_FILTERS: CSSProperties = {
  width: `calc(var(--container) + 2 * var(${FULLBLEED_LEFT_SIZE}) - ${LEFT_SIDE_PADDING})`,
};
